import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { AiOutlineLogout } from 'react-icons/ai';

const Navigation = (props) => {
   const [toggle, isToggled] = useState(false);
   const handleLogout = () => {
      sessionStorage.removeItem('user');
      window.location = '/login';
   };

   const handleToggle = () => {
      isToggled(!toggle);
   };
   const onClickMenuItem = () => {
      if (toggle === true);
      isToggled(false);
   };
   // console.log(JSON.parse(sessionStorage.getItem('user')));
   return (
      <header>
         <nav
            className='navbar box-shadow-y is-blue-custom'
            role='navigation'
            aria-label='main navigation'
         >
            <div className='navbar-brand'>
               <a
                  className='navbar-item'
                  href='https://comzafrica.com'
                  target='_blank'
                  rel='noopener noreferrer'
               >
                  <img
                     src='https://i.ibb.co/Scbqwkj/logo-estep.png'
                     alt='logo'
                     width='80'
                     height='40'
                  />
               </a>
               <div
                  role='button'
                  className={`navbar-burger burger ${toggle ? 'is-active' : ''}`}
                  aria-label='menu'
                  aria-expanded='false'
                  data-target='navbarBasicExample'
                  onClick={handleToggle}
               >
                  <span aria-hidden='true'></span>
                  <span aria-hidden='true'></span>
                  <span aria-hidden='true'></span>
               </div>
            </div>
            <div className={`navbar-menu ${toggle ? 'is-active' : ''}`}>
               {sessionStorage.getItem('user') && (
                  <div className='navbar-end'>
                     <Link className='navbar-item' to='/vend' onClick={onClickMenuItem}>
                        Vending
                     </Link>
                     <Link className='navbar-item' to='/sales' onClick={onClickMenuItem}>
                        Sales History
                     </Link>
                     <Link className='navbar-item' to='/favorites' onClick={onClickMenuItem}>
                        Favorites
                     </Link>
                     <Link className='navbar-item' to='/account' onClick={onClickMenuItem}>
                        My Account
                     </Link>
                     <Link className='navbar-item' to='' onClick={handleLogout}>
                        <AiOutlineLogout />
                     </Link>
                  </div>
               )}
            </div>
         </nav>
      </header>
   );
};

export default Navigation;
